export default "__VITE_ASSET__D$eg110R__"